import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NavButtonsComponent } from '../nav_buttons.component';
import { REDCRSS_EVENTS } from '../../../../shared/services/constants/redcross_evemts';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { IntegrateState } from '../../../integrate/state/integrate_state';
import { PlatformService } from '../../../../shared/services/platforms/platform.service';
import { FeatureService } from '../../services/feature.service';
import { ShopifyService } from '../../services/shopify.service';
import { navToB2B } from '../state/navigation_actions_creator';
import { IAppState } from '../../../../app_state';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Component({
  selector: 'yi-install-later',
  template: require('./integration_step_nav.component.html'),
  styles: [require('../nav_buttons.components.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class IntegrationStepNavComponent extends NavButtonsComponent {

  showInstallLater;
  isShopify2 = false;

  constructor(protected redCross: AnalyticsTrackingProvider, protected store: Store<IAppState>, protected router: Router,
              private IntegrateStateStore: Store<IAppState>, private platformService: PlatformService,
              protected featureService: FeatureService, protected shopifyService: ShopifyService) {
    super(redCross, store, router, featureService, shopifyService);
    this.IntegrateStateStore.select(state => state.app.install.integrate).subscribe(
      (state: IntegrateState) => {
        this.isShopify2 = !!state.shopifyDeeplink;
        if (this.platformService.isVolusion2PlatformType(state.platform)) {
          this.showInstallLater = false;
        } else {
          this.showInstallLater = true;
        }
      });
  }

  skipClickedOn() {
    this.redCross.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: 'I will install it later'
    });

    this.redCross.track(REDCRSS_EVENTS.ONBOARDING, {
      category: 'Reviews',
      phaseName: 'Onboarding Step 3',
      phase: 3,
      status: 'completed',
      ctaText: 'install later'
    });

    this.redCross.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
      product: REDCRSS_EVENTS.PRODUCT,
      stepName: REDCRSS_EVENTS.INTEGRATE,
      stepNum: 3,
      status: REDCRSS_EVENTS.COMPLETED,
      isWidgetV3: this.isWidgetV3,
      isSkipped: 1,
      endScenario: REDCRSS_EVENTS.INSTALL_LATER
    });

    this.featureService.setFeatureSettings('InstallationV2',
      {
        settings: {
          install_status: 'Skipped'
        }
      }
    ).subscribe();

    this.store.dispatch(navToB2B());
  }

  backClickedOn() {
    this.redCross.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
      product: REDCRSS_EVENTS.PRODUCT,
      stepName: REDCRSS_EVENTS.INTEGRATE,
      stepNum: 3,
      status: REDCRSS_EVENTS.BACK,
      isWidgetV3: this.isWidgetV3
    });
    super.backClickedOn();
  }
}
